import { Call } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import type { ContentCommonProps } from './content-common-props';

export default function ContentCall({ message }: ContentCommonProps) {
  const { t } = useTranslation();

  return (
    <div className='chat-bubble items-center break-all text-left group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary'>
      <div className='mx-auto flex h-full items-center gap-4 rounded-lg py-2 px-4 group-data-quote:text-neutral-content'>
        <Call className='size-6' />

        <div className='flex max-w-80vw flex-1 flex-col'>
          <div className='truncate'>{t('message.call')}</div>

          <div className='text-xs group-data-receiver:text-secondary'>{message.Message.split('|').at(0)}</div>
        </div>
      </div>
    </div>
  );
}
